 const enTranslations = {
  // header
  home: "Home",
  about: "Our Team",
  services: "Services",
  contact: "Contact",

  // reserve button
  reserve: "Book Now",
  book: "Book",
  bookHer: "Book With Her",

  // home page
  welcome: "From recovery to performance, we’ve got you covered!",
  
  doYouFeel: "Do you feel...",
  chronicPainProblem: "#Chronic pain",
  chronicPainDescription: "“Chronic pain that never seems to go away.”",
  mobilityProblem: "#Limited mobility",
  mobilityDescription: "“Stuck and can’t move the way you used to.”",
  injuryProblem: "#Post-injury recovery",
  injuryDescription: "“Weak and frustrated after a injury.”",
  surgeryProblem: "#Post-surgery rehab",
  surgeryDescription: "“Your body isn’t healing properly after surgery.”",

  takecare: "LogY takes care of you",
  ourservice: "Our services",
  massage: "Massage Therapy",
  physicRehab: "Physical Rehabilitation",
  perforFitness: "Performance & Fitness",
  chineseMedicine: "Chinese Medicine Approach",

  professional: "We are professional",
  csepCertified: "CSEP certified",
  amqRegistered: "AMQ registered",
  nscaCertified: "NSCA certified",
  pnCertified: "PN certified",

  weHelpPeople: "We’ve helped countless people relax and recover",
  reviewer1: "Yi Ling Ji",
  review1: "“Usually after my tennis tournaments, I’d often feel uncomfortable especially around my back. My knee has also been a problem since I started this sport, though after going to Ruoyan’s clinic, I felt much better and more relieved.”",
  reviewer2: "sadra yeganeh",
  review2: "“Ruoyan is a legend in her field. I limped along when I went in, but I came out looking like nothing happened!”",
  reviewer3: "Chenlu",
  review3: "“Exceptional experience with Ruoyan. The atmosphere was welcoming and soothing. Her expert hands worked wonders, relieving tension and promoting deep relaxation. I am already looking forward to my next session. Highly recommend!”",
  reviewer4: "Mingming Dong",
  review4: "“Incrediable massage with Ruoyan. Highly recommended if you also sitting all day during work. My shoulder and lower back get much better after the session.”",
  reviewer5: "Akshay Shripathi",
  review5: "“Great experience. Really enjoyed the massage”",
  reviewer6: "Shan Zhong",
  review6: "“Professional service from Mcgill's Kinesiologie background massagist, really good body relaxing experience here! Definitely coming back!”",

  findUsHere: "Find Us Here",
  addressTitle: "LogY Kinésiologie",
  addressDetail: "1470 Rue Peel suite 820, Montréal, QC, H3A 1T1",
  metroStation: "Next to Peel Metro station",
  openHour: "Monday to Sunday 10am - 8pm",
  phoneNumber: "(514) 430-6518",

  // about page 
  ourMission: "Our mission",
  missionStatement: "We are committed to promoting fitness as a lifelong habit and a pathway to healthier living in the Montreal community through personalized, research-based programs. Our multidisciplinary team of physiotherapists, kinesiologists, personal trainers, and massage therapists seamlessly integrates injury prevention, rehabilitation, and performance enhancement to support each client’s unique goals. By fostering collaboration among professionals, we set new standards for multidisciplinary care, empowering individuals to achieve their full potential in a supportive and inclusive environment.",
  meetOurTeam: "Meet our team",
  followUs: "Follow us",

  // service page
  allPricesTaxExcluded: "*All prices are tax excluded",

  // contact page
  contactUs: "Contact us",
  findUs: "Find us here",
  sendMessage: "Send a message",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email address",
  phone: "Phone",
  message: "Message",
  send: "Send",
  messageSent: "Message sent! We will get back to you soon.",

  // footer
  receptionEmail: "logy.reception@gmail.com",

  career: "Careers",
  wantToJoin: "Interested in joining LogY? Send your cv to:",
  infoEmail: "info@logykinesiologie.ca",

  stayConnect: "Stay Connected",
  stayUpdated: "Stay updated with our latest promotions, events, and news.",
  emailPlaceholder: "Enter your email",
  subscribe: "Subscribe",
  subscribeSuccess: "Thank you for subscribing!",
  
  join: "Join Our Team",
  homeDescription: "Our expert team helps you move better, feel stronger, and live pain-free. Whether recovering from an injury or managing chronic pain, we'll guide you every step in a supportive, welcoming space.",
  servicesList: "Kinesiology • Massage • Rehab • Fitness",
  
  // Add more translations as needed
};

export default enTranslations;
